import React from 'react'
import { Navigate } from 'react-router-dom';
import { useTenant } from '../../contexts/TenantContext';
import HomePage from '../../pages/Home/HomePage';
import { canAccessDashboardRoutes } from '../../constants/dashboardAccessPermissions';
import { isSurveyOnlyUser } from '../../constants/permissions';

/* Home: survey-only → Overview; dashboard-only → /dashboards; else HomePage */
const HomeEntry = () => {
    const { loading, hasPermission, hasRole, userPermissions } = useTenant();

    if(loading) {
        return null;
    }

    // Client Viewer users should land on shared dashboards instead of Home.
    if (hasRole('Client Viewer')) {
        return <Navigate to="/dashboards?filter=shared" replace />;
    }

    if (isSurveyOnlyUser(userPermissions)) {
        return <Navigate to="/survey" replace />;
    }

    const hasCreateOrEdit =
        hasPermission('create_dashboard') || hasPermission('edit_dashboard');
    const dashboardOnly =
        canAccessDashboardRoutes(hasPermission) && !hasCreateOrEdit;

    if (dashboardOnly) {
        return <Navigate to="/dashboards" replace />;
    }

    return <HomePage />;
};

export default HomeEntry;
